import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'pay',
    lazy: async () => ({ Component: (await import('./PayPage')).PayPage }),
  },
];
